import React from 'react';

const NotFound = () => {
    // Codigo

    // HTML
    return(
        <>
            <h1> Not Found </h1>
        </>
    )
}

export default NotFound;